export const roadmapSlider = [
    {
        title: "Big Bang  Q1 2022",
        label: "1 QUARTAL",
        text: "Start of development of unique animated NFT planets. At the moment, we have crossed the mark of 700+ planets.",
    },
    {
        title: "Ancient world  Q2 2022",
        label: "",
        text: "Information campaign in social media, creation of the official website of ICPlanets, launch of a marketing campaign.",
    },
    {
        title: "Gravity Q3 2022",
        label: "",
        text: "Collecting addresses for Airdrop ( June- July ).",
    },
    {
        title: "The era of substance Q3",
        label: "",
        text: "End of July 2022 - release of a collection of 3.000 planets, 50 will be unique",
    },
    {
        title: "Planets Q4",
        label: "",
        text: "Airdrop will be 10% from total supply.",
    },
    {
        title: "Crystalline Q4",
        label: "",
        text: "Start of development of unique NFT crystals in. A crystal it's a tool for mining a resource on planets using staking.",
    },
    {
        title: "Deep light Q4",
        label: "",
        text: "The process of creating NFT Stars that will be included in the mining ecosystem of the Planets.",
    },
]
export const gallerySlider = [
    {
        title: "Starfire Aurora",
        label: "#1077",
        text: "This planet contains the mysteries of ancient civilization",
        poster: "1.jpg",
        video: "PL_032_1.webm",
    },
    {
        title: "Fateless Neith",
        label: "#1078",
        text: "The planet's star is about to become a supernova. The end is inevitable.",
        poster: "2.jpg",
        video: "PL_032_2.webm",
    },
    {
        title: "Amadeus",
        label: "#1079",
        text: "Au undiscovered planet sends an unknown signal to space every 100 years",
        poster: "3.jpg",
        video: "PL_032_3.webm",
    },
    {
        title: "Planet - X",
        label: "#1080",
        text: "On Planet-X, any available electronic devices will not work. Landing and exploring in not available.",
        poster: "4.jpg",
        video: "PL_032_4.webm",
    },
    {
        title: "Eladan",
        label: "#1080",
        text: "Home of the last ancient civilization.",
        poster: "5.jpg",
        video: "PL_032_5.webm",
    },
    {
        title: "Tiat",
        label: "#1080",
        text: "Supergiant planet, located in the habitable zone.",
        poster: "6.jpg",
        video: "PL_032_6.webm",
    },
    {
        title: "Aradriel",
        label: "#1080",
        text: "The largest planet in the galaxy, attracts entire star systems to itself with the help of gravity.",
        poster: "7.jpg",
        video: "PL_032_7.webm",
    },
    {
        title: "Cassidity",
        label: "#1080",
        text: "The planet was once a bio laboratory for a super advanced civilization, 12,000 years ago.",
        poster: "8.jpg",
        video: "PL_032_8.webm",
    },
    {
        title: "Infinity",
        label: "#1080",
        text: "The planet has an unknown Portal of Worlds, which is guarded by higher civilizations. For 100,000 years from there no one went out and entered.",
        poster: "9.jpg",
        video: "PL_032_9.webm",
    },
    {
        title: "Contributing",
        label: "#1080",
        text: "The Internet Computer blockchain only recently launched but",
        poster: "10.jpg",
        video: "PL_032_10.webm",
    },
]